import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { OverlayModule } from 'angular-io-overlay/src/overlay';
import { ScriptHackModule } from '../shared/components/script-hack/script-hack.module';
import { BetalabsAnalyticsComponent } from './betalabs-analytics.component';

@NgModule({
    declarations: [
        BetalabsAnalyticsComponent
    ],
    imports: [
        BrowserModule,
        CommonModule,
        OverlayModule,
        ScriptHackModule
    ],
    exports: [
        BetalabsAnalyticsComponent
    ]
})
export class BetalabsAnalyticsModule {}



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/app/betalabs-analytics/betalabs-analytics.module.ts